import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
var _excluded = ["children"];
import { Component, createElement } from 'react';
import { cloneEnumerableProperty } from './clone-enumerable-property';
var hasSymbol = typeof Symbol === 'function' && Symbol["for"];
export var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol["for"]('react.forward_ref') : 0xead0;
export var REACT_MEMO_TYPE = hasSymbol ? Symbol["for"]('react.memo') : 0xead3;
export function isReactClass(obj) {
  if (!obj) {
    return false;
  }
  if (obj.prototype && (obj.prototype.isReactComponent || obj.prototype instanceof Component)) {
    return true;
  }
  return false;
}
export function acceptsRef(obj) {
  var _obj$prototype;
  if (!obj) {
    return false;
  }
  if (obj !== null && obj !== void 0 && (_obj$prototype = obj.prototype) !== null && _obj$prototype !== void 0 && _obj$prototype.isReactComponent || isForwardOrMemoForward(obj)) {
    return true;
  }
  return false;
}
export function isForwardRefType(obj) {
  if (!obj || !(obj !== null && obj !== void 0 && obj.$$typeof)) {
    return false;
  }
  return (obj === null || obj === void 0 ? void 0 : obj.$$typeof) === REACT_FORWARD_REF_TYPE;
}
export function isMemoType(obj) {
  if (!obj || !(obj !== null && obj !== void 0 && obj.$$typeof)) {
    return false;
  }
  return obj.$$typeof === REACT_MEMO_TYPE;
}
export function isForwardOrMemoForward(obj) {
  if (!obj || !(obj !== null && obj !== void 0 && obj.$$typeof)) {
    return false;
  }
  return (
    // React.forwardRef(..)
    isForwardRefType(obj) ||
    // React.memo(React.forwardRef(..))
    isMemoType(obj) && isForwardRefType(obj.type)
  );
}
export function isReactComponent(obj) {
  if (!obj) {
    return false;
  }
  return Boolean(isReactClass(obj) || typeof obj === 'function' || isForwardRefType(obj) || isMemoType(obj));
}
export function wrapReactClass(view) {
  var ViewComponentClass = /*#__PURE__*/function (_Component) {
    _inheritsLoose(ViewComponentClass, _Component);
    function ViewComponentClass() {
      return _Component.apply(this, arguments) || this;
    }
    var _proto = ViewComponentClass.prototype;
    _proto.render = function render() {
      var _this$props = this.props,
        children = _this$props.children,
        other = _objectWithoutPropertiesLoose(_this$props, _excluded);
      return /*#__PURE__*/createElement(view, other, children);
    };
    return ViewComponentClass;
  }(Component);
  ViewComponentClass = cloneEnumerableProperty(ViewComponentClass, view);
  ViewComponentClass.displayName = view.displayName;
  return ViewComponentClass;
}